import {
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  Box,
  Button,
  Divider,
  Checkbox,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Chip,
} from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import React, { useEffect, useRef, useState } from "react";
import SearchBox from "../../common/components/SearchBox";
import { connect } from "react-redux";
import { getVotingUnits } from "../../../store/structure/actions";
import { saveVotingGroup } from "../../../store/voting/actions";

const NewGroupDialog = (props) => {
  const {
    loading,
    onWait,
    showGroupDialog,
    setShowGroupDialog,
    units,
    user,
    getVotingUnits,
    saveVotingGroup,
  } = props;
  const [searchTeam, setSearchTeam] = useState("");
  const [filteredUnits, setFilteredUnits] = useState([...units]);
  const containerRef = useRef(null);
  const bottomRef = useRef(null);
  const [checked, setChecked] = useState([]);
  const [formData, setFormData] = useState({
    name: "",
    openingDate: null,
    closingDate: null,
    unitIds: [],
  });
  useEffect(() => {
    getVotingUnits(user.selectedEntitySector.unitId);
  }, []);

  useEffect(() => {
    const filtered = [...units].filter(({ unitName }) =>
      (unitName || "").toLowerCase().includes(searchTeam.toLowerCase())
    );

    setFilteredUnits(filtered);
  }, [searchTeam, units]);

  const [errors, setErrors] = useState({
    nameHasError: false,
    openingDateHasError: false,
    closingDateHasError: false,
    unitIdsHasError: false,
    hasError: false,
  });
  const formValidator = () => {
    const error = {
      nameHasError: false,
      openingDateHasError: false,
      closingDateHasError: false,
      unitIdsHasError: false,
      hasError: false,
    };

    if (!formData.name) {
      error.nameHasError = true;
      error.hasError = true;
    }

    if (!formData.openingDate) {
      error.openingDateHasError = true;
      error.hasError = true;
    }
    if (!checked.length) {
      error.unitIdsHasError = true;
      error.hasError = true;
    }
    if (!formData.closingDate) {
      error.closingDateHasError = true;
      error.hasError = true;
    }
    setErrors(error);

    if (error.hasError) {
      // showError("Please fill out all required fields");
      return true;
    }
    return false;
  };

  const onSave = () => {
    if (!formValidator()) {
      formData.unitIds = checked;
      saveVotingGroup(formData, onClose);
    }
  };
  //getVotingUnits
  const onClose = () => {
    setFormData({
      name: "",
      openingDate: null,
      closingDate: null,
      unitIds: [],
    });
    setShowGroupDialog(false);
  };

  const handleUnitToggle = (unit) => () => {
    const currentIndex = checked.indexOf(unit.unitId);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(unit.unitId);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    let unitIdsHasError = false;
    setErrors({ ...errors, unitIdsHasError });
    setChecked(newChecked);
  };

  const onSearchUnit = (term) => {
    setSearchTeam(term);
  };

  return (
    <>
      <Dialog
        // onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={showGroupDialog}
        fullWidth
        maxWidth={"md"}
      >
        <DialogTitle className="text-primary">
          <Typography
            variant="overline"
            className="text-truncate"
            display="block"
            style={{ maxWidth: "70%" }}
          >
            <div className="headerorg mb-0">
              <div className="header_cont">
                <span className="ml-0 text-dark">New Group</span>
              </div>
            </div>
          </Typography>

          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <span className="material-icons">close</span>
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ width: "100%", minHeight: "60vh" }}>
            <div>
              <div style={{ padding: "0.25rem 1.2rem" }}>
                <div className="form-group1 mb-2">
                  <div className="row">
                    <div className="col-lg-12 mb-1">
                      <TextField
                        fullWidth
                        autoFocus
                        size="small"
                        rows={4}
                        name="name"
                        label="Name"
                        variant="outlined"
                        value={formData.name}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            name: e.target.value,
                          });

                          setErrors({
                            ...errors,
                            nameHasError: false,
                          });
                        }}
                      />
                      {errors.nameHasError && (
                        <small className="text-danger ">
                          Name is required{" "}
                        </small>
                      )}
                    </div>
                    <div className="col-lg-6 mt-1">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          label="Opening Date"
                          inputFormat="MM/dd/yyyy"
                          value={formData.openingDate}
                          onChange={(date) => {
                            setFormData({
                              ...formData,
                              openingDate: date,
                            });

                            setErrors({
                              ...errors,
                              openingDateHasError: false,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField size="small" fullWidth {...params} />
                          )}
                        />
                      </LocalizationProvider>
                      {errors.openingDateHasError && (
                        <small className="text-danger mt-1">
                          The Opening date is required
                        </small>
                      )}
                    </div>
                    <div className="col-lg-6 mt-1">
                      <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <DesktopDatePicker
                          label="Closing Date"
                          inputFormat="MM/dd/yyyy"
                          disabled={!formData.openingDate}
                          value={formData.closingDate}
                          onChange={(date) => {
                            setFormData({
                              ...formData,
                              closingDate: date,
                            });

                            setErrors({
                              ...errors,
                              openingDateHasError: false,
                            });
                          }}
                          renderInput={(params) => (
                            <TextField size="small" fullWidth {...params} />
                          )}
                        />
                      </LocalizationProvider>
                      {errors.closingDateHasError && (
                        <small className="text-danger mt-1">
                          Closing date is required
                        </small>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div className="row w-100 mt-2 ml-1" ref={containerRef}>
                <div className="col-12">
                  <div className="card service-card valid mb-2 mt-1 w-100">
                    <div
                      className="card-header"
                      style={{ padding: "0.25rem 1.2rem" }}
                    >
                      Select unit(s)
                    </div>
                    <div className="card-body">
                      <div className="px-2 pt-2">
                        <SearchBox
                          disabled={!units.length}
                          onSearch={onSearchUnit}
                          placeholder="Search unit(s) ..."
                        />
                      </div>
                      <List
                        sx={{
                          width: "100%",
                          bgcolor: "background.paper",
                          maxHeight: "400px",
                          overflowY: "auto",
                        }}
                      >
                        {filteredUnits.map(
                          ({ unitName, isOnStructure, unitId }) => {
                            const labelId = `checkbox-list-label-${unitId}`;

                            return (
                              <>
                                <ListItem
                                  key={unitId}
                                  disablePadding
                                  style={{
                                    backgroundColor: `${
                                      checked.indexOf(unitId) !== -1
                                        ? "#e9ecef"
                                        : ""
                                    }`,
                                  }}
                                >
                                  <ListItemButton
                                    role={undefined}
                                    onClick={handleUnitToggle({
                                      unitName,
                                      unitId,
                                    })}
                                    dense
                                  >
                                    <ListItemIcon>
                                      <Checkbox
                                        edge="start"
                                        checked={checked.indexOf(unitId) !== -1}
                                        tabIndex={-1}
                                        disableRipple
                                        inputProps={{
                                          "aria-labelledby": labelId,
                                        }}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      id={labelId}
                                      primary={unitName}
                                      secondary={
                                        <strong
                                          className={`d-flex align-items-center text-dark text-uppercase `}
                                          style={{
                                            cursor: "default",
                                            borderRadius: "8px",
                                            fontSize: "10px",
                                          }}
                                        >
                                          {!isOnStructure && (
                                            <Chip
                                              style={{ borderRadius: "0px" }}
                                              className="ml-1 small-chip"
                                              label="Not on structure"
                                              color="error"
                                              size="small"
                                              variant="outlined"
                                            />
                                          )}
                                        </strong>
                                      }
                                    />
                                  </ListItemButton>
                                </ListItem>
                                <Divider />
                              </>
                            );
                          }
                        )}
                      </List>

                      {errors.unitIdsHasError && (
                        <small className="text-danger mb-1">
                          Please, select unit(s)
                        </small>
                      )}
                    </div>
                  </div>
                </div>

                <div ref={bottomRef}></div>
              </div>
            </div>
          </Box>
        </DialogContent>

        <DialogActions className="d-flex justify-content-center pb-3">
          <Button
            disabled={loading || onWait}
            onClick={onSave}
            color={"primary"}
            variant="contained"
            size="md"
          >
            {onWait ? "Wait.." : <>Save</>}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

const mapStateToProps = ({ loading, onWait, user, units }) => {
  return {
    loading,
    onWait,
    user,
    units,
  };
};
export default connect(mapStateToProps, { getVotingUnits, saveVotingGroup })(
  NewGroupDialog
);
